import { parseRequestLoadedGuard } from './guards/parse-request-loaded.guard';
import { ParseRequestCreatePage } from './pages/parse-request-create-page/parse-request-create-page';
import { Routes } from '@angular/router';
import { ParseRequestCreateGeneralPage } from './pages/parse-request-create-general-page/parse-request-create-general-page';
import { ParseRequestCreateDocumentsPage } from './pages/parse-request-create-documents-page/parse-request-create-documents-page';
import { ParseRequestCreateSummaryPage } from './pages/parse-request-create-summary-page/parse-request-create-summary-page';
import { BrokerParseRequestsPage } from './pages/broker-parse-requests-page/broker-parse-requests-page';
import { ParseRequestCreateSuccessPage } from './pages/parse-request-create-success-page/parse-request-create-success-page';
import { ParseRequestsDetailsPage } from './pages/parse-requests-details-page/parse-requests-details-page';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { ParseRequestsDetailsGeneralPage } from './pages/parse-requests-details-general-page/parse-requests-details-general-page';
import { roleGuard } from '../../core/guards/role.guard';
import { locationsLoadedGuard } from '../locations/guards/locations-loaded.guard';
import { energyInterfacesLoadedGuard } from '../energy-interfaces/guards/energy-interfaces-loaded.guard';
import { supplierContractDraftsLoadedGuard } from '../supplier-contracts/guards/supplier-contract-drafts-loaded.guard';

export const PARSE_REQUESTS_ROUTES: Routes = [
  {
    path: ':parseRequestId',
    canActivate: [parseRequestLoadedGuard],
    children: [
      {
        path: 'create',
        component: ParseRequestCreatePage,
        children: [
          {
            path: 'documents',
            component: ParseRequestCreateDocumentsPage,
          },
          {
            path: 'general',
            component: ParseRequestCreateGeneralPage,
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: 'summary',
            component: ParseRequestCreateSummaryPage,
          },
          {
            path: 'success',
            component: ParseRequestCreateSuccessPage,
          },
          {
            path: '',
            redirectTo: 'documents',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: '',
        component: ParseRequestsDetailsPage,
        canActivate: [supplierContractDraftsLoadedGuard],
        children: [
          {
            path: 'general',
            component: ParseRequestsDetailsGeneralPage,
          },
          {
            path: 'admin',
            canActivate: [
              roleGuard('USER_ADMIN'),
              locationsLoadedGuard,
              energyInterfacesLoadedGuard,
            ],
            loadComponent: () =>
              import('./pages/parse-requests-details-admin-page/parse-requests-details-admin-page').then(
                (c) => c.ParseRequestsDetailsAdminPage,
              ),
          },
          {
            path: '',
            redirectTo: 'general',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },
];

export const BROKER_PARSE_REQUESTS_ROUTES: Routes = [
  {
    path: '',
    component: BrokerParseRequestsPage,
  },
];
